import React from 'react';
import { Image, sounds } from '@whitesharx/starfall-frontend-ui-kit';
import { useModal } from '@whitesharx/starfall-frontend-core';
import {
  containerStyles,
  textStyles,
  imagesContainerStyles,
  crownStyles,
  boardsAndFiguresStyles,
  saleStyles,
} from './styles.css';
import VIPModal from '~/src/components/VIPModal';

const VIPBanner = () => {
  const { isOpen, close, open } = useModal();

  const handleClick = () => {
    sounds.play('click');
    open();
  };

  return (
    <>
      <div role="button" aria-labelledby="VIP Chess" className={containerStyles} onClick={handleClick}>
        <div className={imagesContainerStyles}>
          <Image src="/assets/images/vip/banner-sale.png" className={saleStyles} />
          <Image src="/assets/images/vip/boards-and-figures.avif" className={boardsAndFiguresStyles} />
          <Image src="/assets/images/vip/shine-crown.avif" className={crownStyles} />
        </div>
        <p className={textStyles}>VIP CHESS</p>
      </div>
      {isOpen && <VIPModal onClose={close} />}
    </>
  );
};

export default VIPBanner;
